(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-new"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('activity-navigation')) return;
  const instances = new Set();
  class ActivityNavigation extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.links = [...this.querySelectorAll('[data-an-target]')];
      this.dock = this.querySelector('.an-dock');
      this.switcher = this.querySelector('[data-an-switch]');
      this.status = this.querySelector('.an-status');
      this.pending = new Set();
      instances.add(this);
      const listen = (el, type, fn) => el.addEventListener(type, fn, { signal: this.controller.signal });
      listen(this, 'click', e => this.onClick(e));
      listen(window, 'scroll', () => this.schedule());
      listen(window, 'resize', () => this.schedule());
      listen(window, 'hashchange', () => this.initialHash());
      listen(window, 'load', () => this.initialHash());
      listen(this.switcher, 'change', () => {
        const item = this.items.find(entry => entry.target.id === this.switcher.value);
        if (item) this.go(item.target);
      });
      this.querySelectorAll('dialog').forEach(dialog => {
        listen(dialog, 'click', e => {
          if (e.target.closest('[data-an-close]')) dialog.close();
          if (e.target === dialog) {
            const r = dialog.getBoundingClientRect();
            if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
          }
        });
        listen(dialog, 'close', () => {
          this.opener?.setAttribute('aria-expanded', 'false');
          this.opener?.focus({ preventScroll: true });
        });
      });
      this.editor = this.querySelector('.an-editor');
      if (this.editor) this.bindEditor(listen);
      this.observer = new MutationObserver(records => {
        if (records.some(r => !r.target.closest?.('activity-navigation'))) this.schedule(true);
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.resizeObserver.observe(this);
      this.refresh();
      this.initialHash();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.signupTimer);
      clearTimeout(this.settleTimer);
      this.querySelectorAll('dialog[open]').forEach(d => d.close());
      instances.delete(this);
      instances.forEach(instance => instance.schedule());
    }
    headerHeight() {
      const candidates = document.querySelectorAll('.shopify-section-header, [data-an-header]');
      let bottom = 0;
      candidates.forEach(el => {
        const style = getComputedStyle(el);
        if (style.position === 'fixed' || style.position === 'sticky' || el.querySelector('sticky-header')) {
          const top = parseFloat(style.top) || 0;
          bottom = Math.max(bottom, Math.min(innerHeight / 2, el.getBoundingClientRect().height + top));
        }
      });
      return bottom;
    }
    targetFor(link) {
      let id = link.dataset.anTarget || '';
      try { id = decodeURIComponent(id.replace(/^#/, '')); } catch { return null; }
      let target = document.getElementById(id) || document.getElementById('shopify-section-' + id);
      if (!target && /^(?:shopify-section-)?template--[^_]+__.+$/.test(id)) {
        const suffix = '__' + id.split('__').slice(1).join('__');
        const main = this.closest('main') || document.querySelector('main');
        const matches = [...(main?.querySelectorAll('[id^="shopify-section-template--"]') || [])].filter(section => section.id.endsWith(suffix));
        if (matches.length === 1) target = matches[0];
      }
      return target && !this.contains(target) && !target.contains(this) ? target : null;
    }
    refresh() {
      this.items = [];
      this.links.forEach(link => {
        const target = this.targetFor(link);
        if (target && target.getClientRects().length) {
          link.removeAttribute('aria-disabled');
          link.setAttribute('href', '#' + target.id);
          this.items.push({ link, target });
        } else link.setAttribute('aria-disabled', 'true');
      });
      this.items.sort((a,b) => a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top);
      this.switcher.replaceChildren(new Option('Choose an activity', ''));
      const seen = new Set();
      this.items.forEach(({ link, target }) => {
        if (seen.has(target.id)) return;
        seen.add(target.id);
        this.switcher.add(new Option(link.dataset.anLabel || link.textContent.trim(), target.id));
      });
      if (this.editor) this.fillEditor();
      this.update();
    }
    schedule(refresh = false) {
      this.needsRefresh ||= refresh;
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.needsRefresh) { this.needsRefresh = false; this.refresh(); }
        else this.update();
      });
    }
    stickyEnabled() { return matchMedia('(max-width:749px)').matches ? this.dataset.stickyMobile === 'true' : this.dataset.stickyDesktop === 'true'; }
    update() {
      const header = this.headerHeight();
      this.style.setProperty('--an-header', header + 'px');
      const eligible = [...instances].filter(instance => instance.stickyEnabled() && instance.items?.length && instance.getBoundingClientRect().bottom <= header);
      const owner = eligible.sort((a,b) => b.getBoundingClientRect().bottom-a.getBoundingClientRect().bottom)[0];
      this.dock.hidden = owner !== this;
      const threshold = header + (owner ? owner.dock.getBoundingClientRect().height : 0) + Number(this.dataset.gap || 20) + 8;
      let current = null;
      this.items.forEach(item => { if (item.target.getBoundingClientRect().top <= threshold) current = item.target.id; });
      if (this.items.length && scrollY + innerHeight >= document.documentElement.scrollHeight - 3 && scrollY > 0) current = this.items.at(-1).target.id;
      this.links.forEach(link => {
        const item = this.items.find(entry => entry.link === link);
        if (this.dataset.highlight !== 'false' && item && item.target.id === current) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      if (document.activeElement !== this.switcher) this.switcher.value = current || '';
    }
    go(target, behavior) {
      const sticky = this.stickyEnabled();
      const header = this.headerHeight();
      const oldHidden = this.dock.hidden;
      if (sticky) this.dock.hidden = false;
      const offset = header + (sticky ? this.dock.getBoundingClientRect().height : 0) + Number(this.dataset.gap || 20);
      this.dock.hidden = oldHidden;
      const y = Math.max(0, target.getBoundingClientRect().top + scrollY - offset);
      const oldTab = target.getAttribute('tabindex');
      if (oldTab === null) {
        target.setAttribute('tabindex', '-1');
        target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
      target.focus({ preventScroll: true });
      window.scrollTo({ top: y, behavior: behavior || (matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth') });
      try { history.replaceState(null, '', '#' + encodeURIComponent(target.id)); } catch {}
      this.status.textContent = '';
      this.schedule();
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.schedule(), 550);
    }
    initialHash() {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      const item = this.items?.find(entry => entry.target.id === id);
      if (item) this.go(item.target, 'instant');
    }
    onClick(e) {
      const action = e.target.closest('[data-an-target],[data-an-dialog],[data-an-signup]');
      if (!action || action.closest('activity-navigation') !== this || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (action.hasAttribute('data-an-target')) {
        e.preventDefault();
        const target = this.targetFor(action);
        if (target && target.getClientRects().length) this.go(target);
        else this.status.textContent = 'This activity is currently unavailable. Please choose another activity.';
      } else if (action.dataset.anDialog) {
        const dialog = document.getElementById(action.dataset.anDialog);
        if (dialog && this.contains(dialog)) {
          this.opener = action;
          action.setAttribute('aria-expanded','true');
          dialog.showModal();
          dialog.querySelector('button').focus();
        }
      } else this.signup(action);
    }
    signup(action) {
      if (this.pending.size) return;
      this.pending.add(action);
      action.disabled = true;
      action.setAttribute('aria-busy', 'true');
      const start = Date.now();
      const attempt = () => {
        if (!this.isConnected) return;
        const api = window.omnisend;
        if (api && typeof api.push === 'function' && (!Array.isArray(api) || api.push !== Array.prototype.push)) {
          try {
            api.push(['openForm', this.dataset.formId]);
            this.status.textContent = '';
          } catch { this.status.textContent = 'The signup form is unavailable. Please try again later.'; }
          this.signupTimer = setTimeout(finish, 1000);
        } else if (Date.now() - start >= 8000) {
          this.status.textContent = 'The signup form could not load. Please try again later.';
          finish();
        } else {
          this.status.textContent = 'Loading signup form…';
          this.signupTimer = setTimeout(attempt, 250);
        }
      };
      const finish = () => { this.pending.delete(action); action.disabled = false; action.removeAttribute('aria-busy'); };
      attempt();
    }
    bindEditor(listen) {
      this.picker = this.editor.querySelector('select');
      this.output = this.editor.querySelector('input');
      this.editorMessage = this.editor.querySelector('[data-editor-message]');
      listen(this.picker, 'change', () => { this.output.value = this.picker.value; this.editorMessage.textContent = '已选择。请复制 ID 并粘贴到对应导航项的“目标区域 ID”后保存。'; });
      listen(this.editor.querySelector('[data-locate]'), 'click', () => {
        const target = document.getElementById(this.picker.value);
        if (target) this.go(target);
      });
      listen(this.editor.querySelector('[data-copy]'), 'click', async () => {
        this.output.focus(); this.output.select();
        try { await navigator.clipboard.writeText(this.output.value); this.editorMessage.textContent = '已复制。粘贴到该导航项的“目标区域 ID”，然后点击保存。'; }
        catch { this.editorMessage.textContent = 'ID 已选中，请按 Ctrl+C 或长按复制，再粘贴到“目标区域 ID”。'; }
      });
    }
    fillEditor() {
      const previous = this.picker.value;
      this.picker.replaceChildren(new Option('请选择本页目标区域', ''));
      const main = this.closest('main') || document.querySelector('main') || document.body;
      main.querySelectorAll('[id^="shopify-section-"]').forEach((section, index) => {
        if (section.contains(this) || section.querySelector('activity-navigation') || !section.getClientRects().length) return;
        const heading = section.querySelector('h1,h2,h3,[class*="title"]')?.textContent.trim().replace(/\s+/g,' ').slice(0,60);
        this.picker.add(new Option(`${index + 1}. ${heading || '未命名区块'} — ${section.id}`, section.id));
      });
      this.picker.value = previous;
      this.output.value = this.picker.value;
      const missing = this.links.filter(link => !this.targetFor(link));
      this.editorMessage.textContent = missing.length ? `有 ${missing.length} 个目标不存在或已删除，请重新选择并保存。` : '选择区块后复制 ID，粘贴到对应导航项的“目标区域 ID”。选择工具不会自动写入后台。';
    }
  }
  customElements.define('activity-navigation', ActivityNavigation);
})();


  } catch(e) { console.error(e); }
})();
})();
